module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    staticClass: "ql-page",
    attrs: {
      "id": "ql-page"
    }
  }, [_c('md-card-media-cover', {
    ref: "cardCover",
    staticClass: "ql-page-cover",
    attrs: {
      "id": ("cardCover" + _vm.pageNumber)
    }
  }, [(_vm.ready) ? _c('project-pdf-page', {
    staticClass: "ql-pdf-page",
    class: {
      'night-mode': _vm.showMode,
      'disable-text': _vm.disableText
    },
    attrs: {
      "page": _vm.page,
      "positionedCues": _vm.positionedCues,
      "pageWidth": _vm.pageWidth,
      "pageHeight": _vm.pageHeight,
      "currentCueLayer": _vm.currentCueLayer,
      "issrc": _vm.issrc,
      "svgTrueHeight": _vm.svgTrueHeight
    },
    on: {
      "pdfLoaded": _vm.pdfLoaded,
      "openDialog": _vm.openDialog
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.ready) ? _c('p', [_vm._v("Loading PDF...")]) : _vm._e(), _vm._v(" "), _c('resize-sensor', {
    on: {
      "resize": _vm.resize
    }
  })], 1), _vm._v(" "), (_vm.pageReady) ? _c('div', {
    staticClass: "marker-container",
    style: ({
      left: (_vm.offsetX + "px"),
      width: (_vm.pdfWidth + "px")
    })
  }, [_vm._l((_vm.positionCues), function(cue) {
    return _c('cue-position-marker', {
      key: ("" + (cue.id) + _vm.versionID),
      attrs: {
        "cue": cue,
        "editable": false,
        "locked": _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight
      }
    })
  }), _vm._v(" "), _vm._l((_vm.selectionCues), function(cue) {
    return _c('cue-selection-marker', {
      key: ("" + (cue.id) + _vm.versionID),
      attrs: {
        "cue": cue,
        "editable": false,
        "locked": _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight
      }
    })
  }), _vm._v(" "), _vm._l((_vm.scriptMarkersOnPage), function(marker) {
    return _c('script-marker-overlay', {
      key: ((marker.markerId || marker.id) + "-" + _vm.pageWidth + "-" + _vm.pageHeight),
      attrs: {
        "marker": marker,
        "editable": false,
        "locked": true,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight,
        "scale": Number(_vm.selectedScale)
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.pageReady) ? _c('div', {
    staticClass: "ql-note-container",
    style: ({
      left: (_vm.offsetX + "px"),
      width: (_vm.pdfWidth + "px")
    })
  }, _vm._l((_vm.displayNotes), function(note) {
    return _c('project-note-template', {
      key: ("" + (note.id) + _vm.versionID),
      attrs: {
        "note": note,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight,
        "totalPages": _vm.totalPages,
        "selectedElement": _vm.selectedElement
      }
    })
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f55de5a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/print-page.vue
// module id = 1295
// module chunks = 21